<template lang="html">
    <div>
        <div v-if="deleteItem == true">
            <p>Êtes-vous sûr de vouloir supprimer les produits suivants :</p>
            <ul>
                <li v-for="project in $store.state.datatable.products.selected">
                    {{ project.label }}
                </li>
            </ul>
        </div>
        <div v-else>
            <p>Un ou plusieurs projets est lié à un produit, merci de le supprimer afin de procéder à la suppression de ce projet</p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:          'Suppression de projets',
                icon:           'delete',
                warning:        true,
                deleteItem:         true
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                if(this.deleteItem == true) {
                    this.$store.state.datatable.projects.selected.forEach((item, index) => {
                        this.axios.delete(`/api/projects/${item.id}`)
                            .then(response => {
                                this.$eventHub.$emit('close-modal')
                                this.$eventHub.$emit('reload-list')
                            })
                            .catch(err => console.log(err.response.data))
                    })
                } else {
                    this.$eventHub.$emit('close-modal')
                }
            }
        },
        mounted(){
            if(this.$store.state.datatable.projects.selected) {
                this.$store.state.datatable.projects.selected.forEach(item => {
                    this.axios.get(`/api/projects/${item.id}?embed=sidamo_products,supplier_products,competitor_products`)
                    .then(response => {
                        if(response.data.supplier_products_count > 0 || response.data.sidamo_products_count > 0 || response.data.competitor_products_count > 0){
                            this.deleteItem = false
                        }
                    })
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    div {
        padding: 1rem 4rem

        ul {
            margin-left: 3rem
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/projects/list/Delete.vue